import { Paperclip } from "lucide-react"
import { useTranslation } from "react-i18next"

import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@f2e/ui/components/base"

import { UploadingFile } from "./FileUploadTypes"

export const AttachmentBadge = ({
  attachments,
}: {
  attachments: UploadingFile[]
}) => {
  const { t } = useTranslation()
  if (!Array.isArray(attachments) || attachments.length === 0) return null

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="flex items-center cursor-pointer group">
          <Paperclip className="w-4 h-4 text-blue-500" />
          <span className="ml-1 text-xs text-gray-400">
            ({attachments.length})
          </span>
        </span>
      </TooltipTrigger>
      <TooltipContent align="start" className="w-80">
        <div className="text-xs text-gray-700 dark:text-gray-200">
          <div className="font-semibold mb-1">
            {t("evaluation.evaluationTable.detail.attachment")}
          </div>
          {attachments.map((attachment: UploadingFile, idx: number) => (
            <div
              key={attachment.uuid || idx}
              className="flex items-center mb-1"
            >
              <Paperclip className="w-3 h-3 text-blue-500 mr-2 shrink-0" />
              <span className="truncate flex-1">
                {attachment.file?.name || `Attachment ${idx + 1}`}
              </span>
              {attachment.file?.size && (
                <span className="ml-2 text-gray-500 text-xs shrink-0">
                  ({(attachment.file.size / 1024).toFixed(1)}KB)
                </span>
              )}
            </div>
          ))}
        </div>
      </TooltipContent>
    </Tooltip>
  )
}

export default AttachmentBadge
